import type { JSX } from 'solid-js';
import { Btn } from '~/components/primitives/btn';
import { Window } from '~/components/primitives/window';
import { Glyph } from '~/components/glyph';

interface GeolocationPrePromptProps {
  onContinue: () => void;
  onDecline: () => void;
}

const containerStyle: JSX.CSSProperties = {
  position: 'absolute',
  inset: 0,
  background: 'var(--sf-overlay)',
  'backdrop-filter': 'blur(4px)',
  display: 'flex',
  'align-items': 'flex-start',
  'justify-content': 'center',
  'padding-top': '64px',
  'padding-bottom': '14px',
  'z-index': 50,
};

const windowStyle: JSX.CSSProperties = {
  width: 'calc(100% - 14px)',
  'max-width': '340px',
  color: 'var(--fg)',
};

export function GeolocationPrePrompt(props: GeolocationPrePromptProps) {
  return (
    <div style={containerStyle}>
      <Window title="ENABLE LOCATION SIGNAL" dot="data" style={windowStyle}>
        <div
          style={{
            padding: '14px 14px 12px',
            display: 'flex',
            'flex-direction': 'column',
            gap: '12px',
          }}
        >
          <div
            style={{
              display: 'flex',
              'align-items': 'flex-start',
              gap: '10px',
            }}
          >
            <span
              style={{
                width: '10px',
                height: '10px',
                background: 'var(--data)',
                'flex-shrink': 0,
                'margin-top': '5px',
              }}
            />
            <div style={{ flex: 1 }}>
              <div
                class="t-mono"
                style={{
                  'font-size': '13px',
                  color: 'var(--fg)',
                  'letter-spacing': '0.04em',
                  'margin-bottom': '8px',
                }}
              >
                OPERATOR POSITION REQUIRED
              </div>
              <div
                style={{
                  'font-family': 'var(--mono)',
                  'font-size': '11.5px',
                  'line-height': '1.55',
                  color: 'var(--fg-mute)',
                  'letter-spacing': '0.02em',
                }}
              >
                GRID//OS renders your operator dot on the grid using your device's location. The
                signal stays on your device — no location data leaves your phone in this build.
              </div>
            </div>
          </div>

          <div
            class="panel-elev"
            style={{
              padding: '8px 10px',
              display: 'flex',
              'flex-direction': 'column',
              gap: '4px',
            }}
          >
            <div class="t-micro">NEXT · BROWSER WILL ASK FOR LOCATION</div>
            <div
              style={{
                'font-family': 'var(--mono)',
                'font-size': '10.5px',
                color: 'var(--fg-dim)',
                'line-height': '1.5',
              }}
            >
              Tap CONTINUE, then ALLOW on the system prompt that follows. You can opt out by tapping
              NOT NOW.
            </div>
          </div>

          <div style={{ display: 'flex', gap: '8px' }}>
            <Btn onClick={props.onDecline} style={{ flex: 1, 'justify-content': 'center' }}>
              NOT NOW
            </Btn>
            <Btn
              variant="primary"
              onClick={props.onContinue}
              style={{ flex: 2, 'justify-content': 'center' }}
            >
              <Glyph name="arrow" size={12} /> CONTINUE
            </Btn>
          </div>
        </div>
      </Window>
    </div>
  );
}
